(() => {
  const initializeMenu = (menu) => {
    if (menu.dataset.decoMobileMenuReady === "true") return;
    menu.dataset.decoMobileMenuReady = "true";

    const openButton = document.querySelector(`[aria-controls="${menu.id}"]`);
    const closeButtons = [...menu.querySelectorAll("[data-deco-mobile-menu-close]")];
    const panel = menu.querySelector(".deco-mobile-menu__panel");
    let lastFocusedElement = null;

    const focusableElements = () => [...menu.querySelectorAll('a[href], button:not([disabled]), summary, [tabindex]:not([tabindex="-1"])')]
      .filter((element) => element.offsetParent !== null);

    const openMenu = () => {
      lastFocusedElement = document.activeElement;
      menu.classList.add("is-open");
      menu.setAttribute("aria-hidden", "false");
      openButton?.setAttribute("aria-expanded", "true");
      document.body.classList.add("deco-mobile-menu-open");
      window.requestAnimationFrame(() => panel?.focus());
    };

    const closeMenu = () => {
      menu.classList.remove("is-open");
      menu.setAttribute("aria-hidden", "true");
      openButton?.setAttribute("aria-expanded", "false");
      document.body.classList.remove("deco-mobile-menu-open");
      lastFocusedElement?.focus();
    };

    openButton?.addEventListener("click", openMenu);
    closeButtons.forEach((button) => button.addEventListener("click", closeMenu));
    menu.querySelectorAll("a[href]").forEach((link) => link.addEventListener("click", closeMenu));
    menu.addEventListener("keydown", (event) => {
      if (event.key === "Escape") {
        closeMenu();
        return;
      }
      if (event.key !== "Tab") return;
      const items = focusableElements();
      if (!items.length) return;
      const first = items[0];
      const last = items[items.length - 1];
      if (event.shiftKey && document.activeElement === first) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first.focus();
      }
    });

    const desktopQuery = window.matchMedia("(min-width: 1200px)");
    desktopQuery.addEventListener("change", (event) => {
      if (event.matches && menu.classList.contains("is-open")) closeMenu();
    });
  };

  const initializeAll = (root = document) => {
    root.querySelectorAll("[data-deco-mobile-menu]").forEach(initializeMenu);
    root.querySelectorAll(".deco-site-header__nav").forEach((navigation) => {
      if (navigation.dataset.decoDesktopMenuReady === "true") return;
      navigation.dataset.decoDesktopMenuReady = "true";
      const groups = [...navigation.querySelectorAll(".deco-site-header__menu-group")];

      groups.forEach((group) => {
        group.addEventListener("toggle", () => {
          if (!group.open) return;
          groups.forEach((otherGroup) => {
            if (otherGroup !== group) otherGroup.removeAttribute("open");
          });
        });
      });

      document.addEventListener("click", (event) => {
        if (navigation.contains(event.target)) return;
        groups.forEach((group) => group.removeAttribute("open"));
      });

      navigation.addEventListener("keydown", (event) => {
        if (event.key !== "Escape") return;
        const openGroup = navigation.querySelector(".deco-site-header__menu-group[open]");
        if (!openGroup) return;
        openGroup.removeAttribute("open");
        openGroup.querySelector("summary")?.focus();
      });
    });
  };

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", () => initializeAll(), { once: true });
  } else {
    initializeAll();
  }

  document.addEventListener("shopify:section:load", (event) => initializeAll(event.target));
})();
